import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowRight, Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background px-4">
      <div className="max-w-lg w-full text-center py-16">
        <img
          src="/assets/anim/lost-coin-404.svg?v=2"
          alt="An animated bitcoin searching in the dark with a torch"
          width={320}
          height={200}
          className="mx-auto mb-6"
          data-testid="img-404-animation"
        />
        <h1 className="text-3xl font-bold text-white mb-3" data-testid="heading-404">
          404, this page is unrecoverable
        </h1>
        <p className="text-slate-400 mb-2">
          Like a seed phrase written on a napkin, it's gone for good.
        </p>
        <p className="text-slate-400 mb-8">
          Fortunately, unlike crypto, pages are easy to replace.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild size="lg" className="bg-teal-600 hover:bg-teal-500 px-6">
            <Link href="/" data-testid="button-404-home">
              <Home className="w-4 h-4 mr-2" /> Back to safety
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-slate-600 hover:bg-slate-800 px-6 text-white">
            <Link href="/insights" data-testid="button-404-insights">
              Browse insights <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </Button>
        </div>
        <p className="text-slate-500 text-xs mt-8">
          Don't want this to happen to your crypto? <Link href="/inheritance" className="text-teal-400 hover:underline">Make a recovery plan</Link>.
        </p>
      </div>
    </div>
  );
}
